import type { WorkMode } from '@heidi/agents/contracts';

export const isWorkHomeEvidenceMode = (view: string, mode: WorkMode): boolean =>
  view === 'home' && mode === 'evidence';
